import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const EducationalActivityRepository = {
  saveEducationalActivityData: (vacId, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/educationalActivities`,
      method: "POST",
      data: data,
    });
  },
  getEducationalActivityData: (vacId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/educationalActivities`,
      method: "GET",
    });
  },
  getAllTypes: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalActivityTypes`,
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllRoles: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalActivityRoles`,
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  updatePoints: (id, points) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalActivity/${id}/points`,
      params: { points: points },
      method: "PUT",
    });
  },

  unlockPoints: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalActivity/${id}/unlockPoints`,
      method: "PUT",
    });
  },

  setComment: (id, comment) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalActivity/${id}/comment`,
      params: { comment: comment },
      method: "PUT",
    });
  },
};
